import React from "react";
import { About } from "../pages/about";
import { Account } from "../pages/account";
import { Login } from "../pages/login";
import { Logout } from "../pages/logout";
import { Private } from "../pages/private";
import { Document } from "../pages/document";
import { DocumentDetails } from "../pages/documentdetails";
import { LoginSuccess } from "../pages/loginsuccess";
import { ReRunAnalysis } from "../pages/rerunanalysis";
import { Clauses } from "../pages/clauses";
import { Taxonomies } from "../pages/taxonomies";
import { GenericDocument } from "../pages/genericdocument";
import { GenericDocumentDetails } from "../pages/genericdocumentdetails";
import {Connectors} from "../pages/connector"
import {Notification} from "../pages/notification"
import AskGenie from "../pages/AskGenie";
import {Alert} from "../pages/alert"
import {Overview} from "../pages/overview"
//import {Documents} from  "../pages/documents"
// import {AskGenie} from "../pages/askgenie"
import {Requirements} from  "../pages/requriement"
import {TechSpec} from  "../pages/techspec"
import {InfrastructureContext} from "../pages/json"
import {Report} from "../pages/report"


const app_client = process.env.REACT_APP_CLIENT;

let nav = [
  { path: "/", name: "Login", element: <Login />, isMenu: false, isPrivate: false },
  //{ path: "/", name: "Login", element: <Overview />, isMenu: false, isPrivate: false },
  { path: "/overview", name: "Overview", element: <Overview />, isMenu: false, isPrivate: false },
  { path: "/about", name: "About", element: <About />, isMenu: false , isPrivate: false },
  { path: "/login", name: "Login", element: <Login />, isMenu: false, isPrivate: false },
  { path: "/private", name: "Private", element: <Private />, isMenu: true, isPrivate: true },
  { path: "/account", name: "Account", element: <Account />, isMenu: true, isPrivate: true },
  { path: "/login-success", name: "LoginSuccess", element: <LoginSuccess />, isMenu: false, isPrivate: false },
  { path: "/logout", name: "Logout", element: <Logout />, isMenu: true, isPrivate: false },
  { path: "/re-run-analysis", name: "ReRunAnalysis", element: <ReRunAnalysis />, isMenu: false, isPrivate: false },
  { path: "/clauses", name: "Clauses", element: <Clauses />, isMenu: false, isPrivate: false },
  { path: "/taxonomies", name: "Taxonomies", element: <Taxonomies />, isMenu: false, isPrivate: false },
  { path: "/connector", name: "Connectors", element: <Connectors />, isMenu: false, isPrivate: false },
  { path: "/notifications", name: "Notification", element: <Notification />, isMenu: false, isPrivate: false },
  { path: "/ask-genie", name: "Ask Genie", element: <AskGenie />, isMenu: true, isPrivate: false },
  { path: "/alert", name: "Alert", element: <Alert />, isMenu: false, isPrivate: false },
  //{ path: "/documents", name: "Documents", element: <Documents />, isMenu: false, isPrivate: false },
  // { path: "/askgenie", name: "AskGenie", element: <AskGenie />, isMenu: false, isPrivate: false },
  { path: "/requirements", name: "Requirements", element: <Requirements />, isMenu: false, isPrivate: false },
  { path: "/tech-spec/:documentid/:documentname", name: "TechSpec", element: <TechSpec />, isMenu: false, isPrivate: false },
  { path: "/tech-spec", name: "TechSpec", element: <TechSpec />, isMenu: false, isPrivate: false },
  { path: "/infrastructure-context", name: "InfrastructureContext", element: <InfrastructureContext />, isMenu: false, isPrivate: false },
  { path: "/infrastructure-context/:documentid/:documentname", name: "InfrastructureContext", element: <InfrastructureContext />, isMenu: false, isPrivate: false },
  { path: "/infrastructure-context/:type", name: "InfrastructureContext", element: <InfrastructureContext />, isMenu: false, isPrivate: false },
  { path: "/report", name: "Report", element: <Report />, isMenu: false, isPrivate: false },
  
];

if (app_client === "generic") {
  nav = nav.concat([
    { path: "/document-list", name: "GenericDocument", element: <GenericDocument />, isMenu: true, isPrivate: false },
    { path: "/document-details/:documentid/:documentname/:type", name: "GenericDocumentDetails", element: <GenericDocumentDetails />, isMenu: true, isPrivate: false },
  ]);
} else {
  nav = nav.concat([
    { path: "/document-list", name: "Document", element: <Document />, isMenu: true, isPrivate: false },
    { path: "/document-details/:documentid/:documentname/:type", name: "DocumentDetails", element: <DocumentDetails />, isMenu: true, isPrivate: false },
  ]);
}

export { nav };
